import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from 'environments/environment';

@Injectable()
export class MonitorService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  call(query?: any) {
    return this.get('/v2/monitor/call', query);
  }

  agent(query?: any) {
    return this.get('/v2/monitor/agent', query);
  }

  analytic(query?: any) {
    return this.get('/v2/agent-monitor', query);
  }

  top(query?: any) {
    return this.get('/v2/agent-top', query);
  }
  getInqueueEmails(tenantId?: any) {
    return this.getFullUrl(environment.url_email + '/getInqueueTotal?tenant_id=' + tenantId);
  }
  getCallDaily(tenantId?: any) {
    return this.getFullUrl(environment.api_evs + '/omap/report/calldaily?tenant_id=' + tenantId);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Monitor.service.ts